export const ApiKey = 'AIzaSyAjUFFn6w4tYi6TOrzVtr4lqR9aG2BHMRI';
